import React from 'react'
import ModalCustom from '../../modal-custom'
import { Button, Col, Form, Row } from 'react-bootstrap'
import { Controller, useForm } from 'react-hook-form'
import Autocomplete from '../../custom/autocomplete'
import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import DatepickerCustom from '../../datepicker-custom'
import { fnDateEn } from '../../../helper/fnDateEn'
import SwalCustom from '../../../alert/swal-custom'
import { createProvidentFundAPI } from '../../../services/provident-fund'
import { TXTSUCCESS } from '../../../Constants'
import Error_false from '../../error/error-false'
import Error_500 from '../../error/error-500'
import UseEmpPVD from './use-EmpPVD'
import { useDebounce } from '@react-hook/debounce'

export default function ModalAddMember({
  isShow,
  onCancel,
  orgId,
  TypePlan,
  fnGetData
}) {
  const schema = yup
    .object({
      name: yup.object().required('โปรดระบุข้อมูล'),
      startDateAdd: yup.string().required('โปรดระบุข้อมูล'),
      percentageAdd: yup.string().required('โปรดระบุข้อมูล')
    })
    .required()
  const {
    reset,
    control,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })
  const [searchs, setSearchs] = useDebounce('', 1000)
  const [keyUsername, setKeyUsername] = useDebounce('', 1000)
  const empPVD = UseEmpPVD(orgId, searchs, keyUsername)

  const onSubmit = (d) => {
    const body = {
      orgId,
      code: d.name.code ?? '',
      username: d.name.value ?? '',
      percent: d.percentageAdd ?? '',
      startDate: d?.startDateAdd,
      planId: d.planNameAdd?.value ?? ''
    }

    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to create new?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#2C5DFE',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, save it!'
    }).then((result) => {
      if (result.isConfirmed) {
        createProvidentFund(body)
      }
    })
  }

  const createProvidentFund = async (body) => {
    try {
      const datas = await createProvidentFundAPI(body)
      if (!datas) return
      if (datas.status === true) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          fnGetData()
          onCancel()
          reset()
        })
      } else {
        Error_false(datas)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  return (
    <ModalCustom destroyOnClose={true} open={isShow} onCancel={onCancel}>
      <Col xl={12}>
        <Row>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <div className="col-12 ">
              <div
                className="fw-normal text-primary "
                style={{
                  fontSize: '20px'
                }}
              >
                Add Member
              </div>

              <div className="row ">
                <div className="fw-normal  pt-4 col-6">
                  <div className="p-1"> Employee </div>
                  <Controller
                    name={'name'}
                    control={control}
                    render={({ field: { onChange, value = '' } }) => (
                      <Autocomplete
                        isClearable={true}
                        options={empPVD}
                        value={value}
                        onChange={(e) => {
                          onChange(e)
                        }}
                        onInputChange={(data) => {
                          setKeyUsername(data)
                          setSearchs(data)
                        }}
                      />
                    )}
                  />
                  {errors.name && (
                    <label className="small text-danger">
                      {errors.name.message}
                    </label>
                  )}
                </div>
                <div className="fw-normal col-6 pt-4 ">
                  <div className="p-1"> Fund Entry Date</div>
                  <Controller
                    name={'startDateAdd'}
                    control={control}
                    render={({ field: { value = '', onChange } }) => (
                      <DatepickerCustom
                        value={value}
                        onChange={([date]) => {
                          onChange(
                            date ? fnDateEn(date).format('YYYY-MM-DD') : ''
                          )
                        }}
                      />
                    )}
                  />
                  {errors.startDateAdd && (
                    <label className="small text-danger">
                      {errors.startDateAdd.message}
                    </label>
                  )}
                </div>
              </div>

              <div className="row">
                <div className="fw-normal col-6 pt-3">
                  <div className="p-1"> % Deducted </div>
                  <Controller
                    name={'percentageAdd'}
                    control={control}
                    render={({ field: { value = '', onChange } }) => (
                      <Form.Control
                        className="w-100"
                        min={1}
                        max={15}
                        type="number"
                        onChange={onChange}
                      />
                    )}
                  />
                  {errors.percentageAdd && (
                    <label className="small text-danger">
                      {errors.percentageAdd.message}
                    </label>
                  )}
                </div>
                <div className="fw-normal col-6 pt-3 pb-0 mb-0">
                  <div className="p-1"> Type of Fund </div>
                  <Controller
                    name={'planNameAdd'}
                    control={control}
                    render={({ field: { value = '', onChange } }) => (
                      <Autocomplete
                        className="w-100"
                        options={TypePlan}
                        value={value}
                        allowClear
                        onChange={(e) => {
                          onChange(e)
                        }}
                      />
                    )}
                  />
                  {errors.planNameAdd && (
                    <label className="small text-danger">
                      {errors.planNameAdd.message}
                    </label>
                  )}
                </div>
              </div>

              <div className="col-12 d-flex mt-5 gap-3 justify-content-center">
                <Button
                  variant="outline-primary"
                  style={{
                    width: '130px'
                  }}
                  size="sm"
                  className="rounded-3"
                  onClick={onCancel}
                >
                  Cancel
                </Button>

                <Button
                  type="submit"
                  variant="primary"
                  style={{
                    width: '130px'
                  }}
                  size="sm"
                  className="rounded-3"
                >
                  Apply
                </Button>
              </div>
            </div>
          </Form>
        </Row>
      </Col>
    </ModalCustom>
  )
}
